import 'regenerator-runtime/runtime';
import axios from 'axios';
import { apimCall } from './helpers/api';
import { appContext } from './AppContext';
import { GoFormzServices } from './AppSettings';
import { ProfileSettings } from './profile/profile-types';

export const FETCH_CLIENTFEATURE = 'FETCH_CLIENTFEATURE';
export const GET_CLIENTFEATURE = 'GET_CLIENTFEATURE';
export const SET_EDITABLE = 'SET_EDITABLE';
export const SASTOKEN_GET_SUCCESS = 'SASTOKEN_GET_SUCCESS';
export const SASTOKEN_GET_FAILURE = 'SASTOKEN_GET_FAILURE';
export const GET_USERINFO_SUCCESS = 'GET_USERINFO_SUCCESS';
export const UPDATE_SETTINGS_FAILURE = 'UPDATE_SETTINGS_FAILURE';
export const UPDATE_SETTINGS_SUCCESS = 'UPDATE_SETTINGS_SUCCESS';
export const UPDATE_PROFILE_USER = 'UPDATE_PROFILE_USER';
export const CLIENT_LOCKED = 'CLIENT_LOCKED';

export const getSasToken = () => (dispatch) => {
  return apimCall(GoFormzServices.FileService, '/files/sas')
    .then((json) => {
      dispatch({
        type: SASTOKEN_GET_SUCCESS,
        payload: {
          sasToken: {
            token: json.data.data.signature,
            baseUrl: `${json.data.data.containerUrl}/filestorage/`
          }
        }
      });
      setTimeout(() => getSasToken()(dispatch), 3600000); // refresh every hour
    })
    .catch((error) =>
      dispatch({
        type: SASTOKEN_GET_FAILURE,
        payload: {
          error: {
            message: error
          }
        }
      })
    );
};

export const updateSettings = (settings: Partial<ProfileSettings>) => (dispatch) => {
  return apimCall(GoFormzServices.AccountService, '/profile/updatesettings', 'POST', settings)
    .then(() =>
      dispatch({
        type: UPDATE_SETTINGS_SUCCESS,
        payload: settings
      })
    )
    .catch((error) =>
      dispatch({
        type: UPDATE_SETTINGS_FAILURE,
        error
      })
    );
};

export const updateProfileUser = (user) => (dispatch) => {
  dispatch({
    type: UPDATE_PROFILE_USER,
    payload: user
  });
};

axios.interceptors.response.use(
  (response) => response,
  async (error) => {
    const status = error?.response?.status;
    if (error.config && status === 503 && error.response.data === 'Client locked') {
      appContext.store.dispatch({
        type: CLIENT_LOCKED
      });
    }
    return Promise.reject(error);
  }
);
